<template>
  <!-- 字体设置——右侧操作按钮 -->
  <div class="rightOperations">
    <div class="leftBox">
      <el-button type="primary" size="small" :disabled="!fontStyleId" @click="addFontOpenDialog">新增</el-button>
      <el-button type="danger" size="small" :disabled="!currentSelectFonts.length" plain @click="deleteTableFont">批量删除</el-button>
      <el-checkbox v-model="checked1" :disabled="!fontStyleId" :true-label="1" :false-label="0" style="margin-left: 20px"
        @change="checkedChange1">
        替换钢筋符号
      </el-checkbox>
      <el-checkbox v-model="checked2" :disabled="!fontStyleId" :true-label="1" :false-label="0" @change="checkedChange2">
        清除文字格式
      </el-checkbox>
    </div>
    <div class="rightBox">
      <el-button type="primary" size="small" style="margin-right: 10px" plain @click="downloadTemplate">
        下载模板
      </el-button>
      <el-upload ref="upload" :disabled="upload || !fontStyleId" :show-file-list="false" :http-request="httpRequest"
        class="upload-file" action="#" accept=".xlsx">
        <el-button type="primary" size="small" :disabled="!fontStyleId" plain @click="upLoadFile">导入配置</el-button>
      </el-upload>
      <el-button type="primary" size="small" :disabled="!fontStyleId" style="margin-left: 10px" plain @click="exportFontSet">
        导出配置
      </el-button>
    </div>

    <!-- 新增弹框 -->
    <el-dialog v-dialogDrag :visible.sync="addFontOpen" title="添加设置" width="27%" top="17vh" class="dialogRevitAddSet"
      :close-on-click-modal="false" :close-on-press-escape="false" @close="resetAddDialog">
      <!-- 表单 -->
      <el-form ref="addForm" :model="addForm" size="small" label-width="120px" :rules="addRules">
        <el-form-item label="Revit文字" prop="revitFont">
          <el-input ref="revitFont" v-model.trim="addForm.revitFont" placeholder="请输入revit字体类型" maxlength="50" clearable></el-input>
        </el-form-item>
        <el-form-item label="CAD文字样式" prop="cadFontStyle">
          <el-input v-model.trim="addForm.cadFontStyle" placeholder="请输入cad字体类型" maxlength="50" clearable></el-input>
        </el-form-item>
        <el-form-item label="SHX字体" prop="shxFont">
          <el-input v-model.trim="addForm.shxFont" placeholder="请输入字体类型" maxlength="50" clearable></el-input>
        </el-form-item>
        <el-form-item label="大字体" prop="bigFont">
          <el-input v-model.trim="addForm.bigFont" placeholder="请输入字体类型" maxlength="50" clearable></el-input>
        </el-form-item>
        <el-form-item label="宽度因子" prop="widthFactor">
          <el-input-number v-model="addForm.widthFactor" placeholder="请输入宽度因子" :min="0.01" :max="100" :precision="2">
          </el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFontOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="addFontSetRight">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入失败弹框 -->
    <el-dialog v-dialogDrag :visible.sync="importFailOpen" title="导入" width="27%" top="23vh" class="dialogRevitImportFail" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="importFail">
        <el-image style="width: 200px;" :src="dangersrc" fit="contain"></el-image>
        <p style="font-size:14px">
          <span style="color:var(--theme-color)">{{ successNum }}</span>条导入成功，
          <span style="color:#E6A23C">{{ failNum }}</span>条导入失败
          <span style="color:var(--theme-color);cursor: pointer;" @click="downloadFailList">下载失败列表</span>
        </p>
        <el-upload ref="uploadRetry" :show-file-list="false" :http-request="httpRequest" class="upload-file" action="#"
          accept=".xlsx">
          <el-button size="small" type="primary" plain>重新导入</el-button>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { disablePrompt } from "@/CommonDP/utils/routeAuth";
import revitSetService from "@/CommonDP/service/revitSet-service";

export default {
  components: {},
  props: ["fontStyleId", "fontStyleName", "currentSelectFonts"],
  data() {
    return {
      dangersrc: require("@/CommonDP/assets/addpersonInfo/导入失败.png"),
      checked1: 0, // 替换钢筋符号
      checked2: 0, // 清除文字格式

      addFontOpen: false, // 新增字体弹框
      addForm: {
        revitFont: "",
        cadFontStyle: "",
        shxFont: "",
        bigFont: "",
        widthFactor: ""
      }, // 新增表单
      addRules: {
        revitFont: [{ required: true, message: "revit字体类型不能为空", trigger: "blur" }],
        cadFontStyle: [{ required: true, message: "cad字体类型不能为空", trigger: "blur" }],
        widthFactor: [
          { required: true, message: "宽度因子不能为空", trigger: "blur" },
          { required: true, message: "宽度因子不能为空", trigger: "change" }
        ]
      }, // 表单验证

      upload: false, // 上传插件
      importFile: "", // 导入文件
      importFailOpen: false, // 导入失败弹框
      successNum: 0, // 导入成功数量
      failNum: 0, // 导入失败数量
      failList: [] // 导入失败列表
    };
  },
  methods: {
    addFontOpenDialog() {
      this.addFontOpen = true;
      this.$nextTick(() => {
        this.$refs.revitFont.focus();
        this.$refs.addForm.resetFields();
      });
    },
    // 添加字体设置右侧
    addFontSetRight() {
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          const { revitFont, cadFontStyle, shxFont, bigFont, widthFactor } = this.addForm;
          const params = {
            fontStyleId: this.fontStyleId,
            revitFont,
            cadFontStyle,
            shxFont,
            bigFont,
            widthFactor
          };
          await revitSetService.addFontSetRight(params);
          await this.$emit("refreshTable");
          this.$message.success("添加字体成功");
          this.addFontOpen = false;
        }
      });
    },
    // 重置新增弹框
    resetAddDialog() {
      this.addForm = {
        revitFont: "",
        cadFontStyle: "",
        shxFont: "",
        bigFont: "",
        widthFactor: ""
      }; // 新增表单
      this.$refs.addForm.resetFields();
    },

    // 删除表中选中的字体
    deleteTableFont() {
      this.$confirm("是否确认要删除这些选中的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        const list = this.currentSelectFonts.map(item => item.fontStyleDetailsId);
        await revitSetService.deleteFontSetList(list);
        await this.$emit("refreshTable");
        this.$message.success("删除成功");
      });
    },

    // 复选框改变事件
    async checkedChange1(val) {
      const params = {
        fontStyleId: this.fontStyleId,
        isReplaceReinforcedSymbol: val,
        isClearFontStyle: this.checked2
      };
      await revitSetService.updateFontSetLeft(params);
      this.$emit("updateCheck", [val, this.checked2]);
    },
    async checkedChange2(val) {
      const params = {
        fontStyleId: this.fontStyleId,
        isReplaceReinforcedSymbol: this.checked1,
        isClearFontStyle: val
      };
      await revitSetService.updateFontSetLeft(params);
      this.$emit("updateCheck", [this.checked1, val]);
    },

    // 下载模板
    async downloadTemplate() {
      const res = await revitSetService.downloadFontTemplate();
      const fileName = "字体样式设置模板.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        // 兼容ie
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // 上传导入配置
    upLoadFile() {
      const a = disablePrompt();
      if (!a) {
        this.upload = true;
      }
    },
    async httpRequest({ file }) {
      this.importFile = file;
      const data = new FormData();
      data.append("fontStyleId", this.fontStyleId);
      data.append("file", file);
      try {
        this.upload = true;
        const res = await revitSetService.importFontSet(data);
        if (res.data.failNum > 0) {
          // 导入失败条数 > 0
          this.successNum = res.data.successNum;
          this.failNum = res.data.failNum;
          this.failList = res.data.failList || [];
          this.importFailOpen = true;
        } else {
          this.importFailOpen = false;
          this.$message.success("导入成功");
        }
        await this.$emit("refreshTable");
      } finally {
        this.upload = false;
      }
    },
    // 导出字体配置
    async exportFontSet() {
      const res = await revitSetService.exportFontSet(this.fontStyleId);
      const fileName = this.fontStyleName + ".xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        // 兼容ie
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    // 下载失败列表
    async downloadFailList() {
      const res = await revitSetService.downloadFontFailList(this.failList);
      const fileName = "字体样式导入失败列表.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        // 兼容ie
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.rightOperations {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .leftBox {
    max-width: calc(100% - 300px);
    display: flex;
    align-items: center;
  }

  .rightBox {
    width: 260px;
    display: flex;
    align-items: center;
  }
}

.el-input-number {
  width: 200px;
  max-width: 100%;
}

/deep/ .el-form-item__label {
  text-align: left;
}

.importFail {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-size: 14px;
  }

  .el-button {
    margin-top: 20px;
  }
}
</style>
